/* RE:AUTO GARAGE — small UI layer (no dependencies) */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const store = {
    get(k) { try { return JSON.parse(localStorage.getItem(k)); } catch (e) { return null; } },
    set(k, v) { try { localStorage.setItem(k, JSON.stringify(v)); } catch (e) {} },
    del(k) { try { localStorage.removeItem(k); } catch (e) {} },
  };
  const handleize = (s) => String(s || '').toLowerCase().replace(/['"]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');

  /* Header: tint on scroll (like the app) */
  const header = $('[data-ra-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* Modals */
  let lastFocus = null;
  const openModal = (m) => {
    if (!m) return;
    lastFocus = document.activeElement;
    m.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
    const f = m.querySelector('input:not([type=hidden]), select, textarea, button');
    if (f) setTimeout(() => f.focus(), 30);
  };
  const closeModal = (m) => {
    if (!m) return;
    m.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-ra-open]');
    if (opener) { e.preventDefault(); openModal(document.getElementById(opener.dataset.raOpen)); return; }
    const closer = e.target.closest('[data-ra-close]');
    if (closer) { closeModal(closer.closest('[data-ra-modal]')); return; }
    if (e.target.matches('[data-ra-modal]')) closeModal(e.target);
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') $$('[data-ra-modal].is-open').forEach(closeModal);
  });
  $$('[data-ra-autoopen]').forEach((el) => openModal(el.closest('[data-ra-modal]')));

  /* Pill filters for product grids.
     "All" shows the newest parts; each category tab shows that category's own
     products, including ones rendered as hidden extras ([data-ra-extra]). */
  $$('[data-ra-products]').forEach((sec) => {
    const pills = $$('[data-ra-filter]', sec);
    const cards = $$('.ra-pcard', sec);
    const counter = $('[data-ra-visible-count]', sec);
    pills.forEach((p) => p.addEventListener('click', () => {
      pills.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
      const v = p.dataset.raFilter;
      let n = 0;
      cards.forEach((c) => {
        const extra = c.closest('[data-ra-extra]');
        const show = extra ? (!!v && c.dataset.type === v) : (!v || c.dataset.type === v);
        c.hidden = !show;
        if (extra) extra.hidden = !show;
        if (show) n++;
      });
      if (counter) counter.textContent = n;
    }));
  });

  /* Local services: search + category pills */
  $$('[data-ra-services]').forEach((sec) => {
    const input = $('[data-ra-services-search]', sec);
    const pills = $$('[data-ra-cat]', sec);
    const items = $$('.ra-service', sec);
    const empty = $('[data-ra-services-empty]', sec);
    let cat = '';
    const apply = () => {
      const q = (input && input.value || '').trim().toLowerCase();
      let n = 0;
      items.forEach((it) => {
        const show = (!cat || it.dataset.cat === cat) && (!q || it.dataset.text.includes(q));
        it.hidden = !show; if (show) n++;
      });
      if (empty) empty.hidden = n > 0;
    };
    if (input) input.addEventListener('input', apply);
    pills.forEach((p) => p.addEventListener('click', () => {
      pills.forEach((x) => x.setAttribute('aria-pressed', String(x === p)));
      cat = p.dataset.raCat; apply();
    }));
  });

  /* Vehicle picker (compatibility) — saved per browser */
  const vehicle = store.get('ra_vehicle');
  const fitTag = (v) => v ? 'fits-' + handleize(v.make + ' ' + v.model) : '';
  if (vehicle) {
    const tag = fitTag(vehicle);
    $$('.ra-pcard').forEach((c) => {
      const fits = (c.dataset.fits || '').split(/\s+/);
      const b = $('[data-ra-fit]', c);
      if (b && fits.includes(tag)) b.hidden = false;
    });
    $$('[data-ra-vehicle-label]').forEach((el) => { el.textContent = 'Your vehicle: ' + [vehicle.year, vehicle.make, vehicle.model].filter(Boolean).join(' '); });
    $$('[data-ra-vehicle-sub]').forEach((el) => {
      el.innerHTML = '';
      const a = document.createElement('a');
      a.href = '/collections/all/' + tag; a.className = 'ra-link'; a.textContent = 'Show parts that fit →';
      el.appendChild(a);
    });
    $$('[data-ra-vehicle-cta]').forEach((el) => { el.textContent = 'Change'; });
  }
  $$('[data-ra-vehicle-form]').forEach((form) => {
    const dataEl = form.parentElement.querySelector('[data-ra-vehicles]');
    let lines = [];
    try { lines = JSON.parse(dataEl.textContent); } catch (e) {}
    const map = {};
    lines.forEach((l) => {
      const i = l.indexOf(':'); if (i < 1) return;
      map[l.slice(0, i).trim()] = l.slice(i + 1).split(',').map((s) => s.trim()).filter(Boolean);
    });
    const make = $('[data-ra-make]', form), model = $('[data-ra-model]', form);
    Object.keys(map).forEach((m) => make.add(new Option(m, m)));
    const fillModels = () => {
      model.length = 1;
      (map[make.value] || []).forEach((m) => model.add(new Option(m, m)));
      model.disabled = !make.value;
    };
    make.addEventListener('change', fillModels);
    if (vehicle) { make.value = vehicle.make; fillModels(); model.value = vehicle.model; form.year.value = vehicle.year || ''; }
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const v = { make: make.value, model: model.value, year: form.year.value.trim() };
      if (!v.make || !v.model) return;
      store.set('ra_vehicle', v);
      window.location.href = '/collections/all/' + fitTag(v);
    });
    const clear = $('[data-ra-vehicle-clear]', form);
    if (clear) clear.addEventListener('click', () => { store.del('ra_vehicle'); window.location.reload(); });
  });

  /* Cart count + quick add */
  const setCount = (n) => $$('[data-ra-cart-count]').forEach((el) => { el.textContent = n; el.dataset.count = n; });
  const refreshCount = () => fetch('/cart.js', { headers: { Accept: 'application/json' } })
    .then((r) => r.json()).then((c) => setCount(c.item_count)).catch(() => {});
  document.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-ra-add]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('button');
    btn.disabled = true;
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then((r) => { if (!r.ok) throw r; return r.json(); })
      .then(() => { btn.classList.add('is-added'); btn.setAttribute('aria-label', 'Added to cart'); refreshCount(); setTimeout(() => btn.classList.remove('is-added'), 1600); })
      .catch(() => { window.location.href = '/cart'; })
      .finally(() => { btn.disabled = false; });
  });
  // Keep header count fresh when Horizon's own product form adds to cart
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const p = origFetch.apply(this, args);
    try {
      const url = String(args[0] && args[0].url || args[0]);
      if (/\/cart\/(add|change|update|clear)/.test(url) && !/\/cart\.js/.test(url)) p.then(() => setTimeout(refreshCount, 150));
    } catch (e) {}
    return p;
  };
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCount(); });

  /* Share */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-ra-share]');
    if (!b) return;
    e.preventDefault();
    const url = b.dataset.raShare, title = b.dataset.title || document.title;
    if (navigator.share) { navigator.share({ title, url }).catch(() => {}); return; }
    if (navigator.clipboard) navigator.clipboard.writeText(url).then(() => {
      const old = b.getAttribute('aria-label'); b.setAttribute('aria-label', 'Link copied'); b.style.color = 'var(--ra-teal)';
      setTimeout(() => { b.setAttribute('aria-label', old); b.style.color = ''; }, 1500);
    });
  });

  /* "2 days ago" timestamps */
  const rtf = window.Intl && Intl.RelativeTimeFormat ? new Intl.RelativeTimeFormat('en', { numeric: 'auto' }) : null;
  if (rtf) $$('[data-ra-ago]').forEach((t) => {
    const d = new Date(t.getAttribute('datetime')); if (isNaN(d)) return;
    const s = (d - Date.now()) / 1000;
    const units = [['year', 31536000], ['month', 2592000], ['week', 604800], ['day', 86400], ['hour', 3600], ['minute', 60]];
    for (const [u, sec] of units) { if (Math.abs(s) >= sec) { t.textContent = rtf.format(Math.round(s / sec), u); return; } }
    t.textContent = 'just now';
  });
})();

/* Chassis: view more */
document.addEventListener('click', function (e) {
  var btn = e.target.closest('[data-ra-more]');
  if (!btn) return;
  var sec = btn.closest('section');
  var open = btn.getAttribute('aria-expanded') === 'true'; if (!btn.dataset.label) btn.dataset.label = btn.innerHTML; sec.querySelectorAll('[data-ra-more-item]').forEach(function (el) { el.hidden = open; }); btn.setAttribute('aria-expanded', String(!open)); btn.innerHTML = open ? btn.dataset.label : 'View less chassis <span class="mz-more__n">&uarr;</span>'; if (open) sec.scrollIntoView({ behavior: 'smooth', block: 'start' });
  
});

/* Journal feature: build contents list from chapter headings */
(function () {
  var art = document.querySelector('[data-ra-feature]');
  if (!art) return;
  var toc = art.querySelector('[data-ra-toc]');
  var hs = art.querySelectorAll('.mz-feature__body h2');
  if (!toc || !hs.length) { if (toc) toc.closest('.mz-feature__side').classList.add('is-empty'); return; }
  hs.forEach(function (h, i) {
    if (!h.id) h.id = 'ch-' + (i + 1);
    var li = document.createElement('li');
    var a = document.createElement('a');
    a.href = '#' + h.id;
    a.innerHTML = '<span>' + String(i + 1).padStart(2, '0') + '</span>' + h.textContent;
    li.appendChild(a);
    toc.appendChild(li);
  });
})();

/* Fit big display words (cover plate, spine, spread) inside their frame */
(function () {
  function fit() {
    document.querySelectorAll('[data-ra-fit]').forEach(function (el) {
      var box = el.parentElement;
      if (!box || !box.clientWidth) return;
      el.style.fontSize = '';
      var vertical = el.getAttribute('data-ra-fit') === 'v';
      var r = el.getBoundingClientRect();
      var size = vertical ? r.height : r.width;
      var avail = vertical ? box.clientHeight * 0.6 : box.clientWidth * 0.92;
      if (size > avail) {
        var fs = parseFloat(getComputedStyle(el).fontSize);
        el.style.fontSize = Math.floor(fs * avail / size) + 'px';
      }
    });
  }
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(fit, 120); });
  document.addEventListener('shopify:section:load', fit);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
  fit();
})();
